import { render } from "./ClipboardTag.vue?vue&type=template&id=40454c35"
import script from "./ClipboardTag.vue?vue&type=script&lang=js"
export * from "./ClipboardTag.vue?vue&type=script&lang=js"

import "./ClipboardTag.vue?vue&type=style&index=0&id=40454c35&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__